function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//@ts-nocheck
export const TextStyleProps = [// TextStyle
'color', 'fontFamily', 'fontSize', 'fontStyle', 'fontWeight', 'letterSpacing', 'lineHeight', 'textAlign', 'textAlign', 'textDecorationLine', 'textDecorationStyle', 'textDecorationColor', 'textShadowColor', 'textShadowColor', 'textShadowOffset', 'textShadowRadius', // TextStyleIOS
'textTransform', 'writingDirection', // TextStyleAndroid
'textAlignVertical', 'includeFontPadding'];
export const FlexStyleProps = ['alignContent', 'alignItems', 'alignSelf', 'aspectRatio', 'borderBottomWidth', 'borderEndWidth', 'borderLeftWidth', 'borderRightWidth', 'borderStartWidth', 'borderTopWidth', 'borderWidth', 'bottom', 'display', 'end', 'flex', 'flexBasis', 'flexDirection', 'flexGrow', 'flexShrink', 'flexWrap', 'height', 'justifyContent', 'left', 'margin', 'marginBottom', 'marginEnd', 'marginHorizontal', 'marginLeft', 'marginRight', 'marginStart', 'marginTop', 'marginVertical', 'maxHeight', 'maxWidth', 'minHeight', 'minWidth', 'overflow', 'padding', 'paddingBottom', 'paddingEnd', 'paddingHorizontal', 'paddingLeft', 'paddingRight', 'paddingStart', 'paddingTop', 'paddingVertical', 'position', 'right', 'start', 'top', 'width', 'zIndex', // ios
'direction'];

class NativePropsService {
  /**
   * Retrieves all props included in `from` array
   *
   * @param source (Props) - source object
   * @param from (string[]) - array of keys needed to retrieve from `source`
   *
   * @return (Partial<Props>) - object with keys contained in `from` array
   */
  all(source, from) {
    if (!source) {
      return {};
    }

    return from.reduce((acc, prop) => {
      return _objectSpread(_objectSpread({}, acc), {}, {
        [prop]: source[prop]
      });
    }, {});
  }
  /**
   * Retrieves all props included in `from` array, rest props includes in under the `rest` key
   */


  allWithRest(source, from) {
    if (!source) {
      return {
        rest: {}
      };
    }

    return Object.keys(source).reduce((acc, prop) => {
      const {
        rest
      } = acc,
            allOf = _objectWithoutProperties(acc, ["rest"]);

      if (from.includes(prop)) {
        return _objectSpread(_objectSpread({}, allOf), {}, {
          [prop]: source[prop],
          rest
        });
      }

      return _objectSpread(_objectSpread({}, allOf), {}, {
        rest: _objectSpread(_objectSpread({}, rest), {}, {
          [prop]: source[prop]
        })
      });
    }, {});
  }
  /**
   * Returns all styles with prefix
   *
   * @param {StyleType} source - Eva Styles
   * @param {string} key - prefix
   *
   * @return {StyleType} - all styles with prefix
   */


  allWithPrefix(source, key) {
    return Object.keys(source).filter(styleName => styleName.includes(key)).reduce((obj, styleKey) => {
      return _objectSpread(_objectSpread({}, obj), {}, {
        [styleKey]: source[styleKey]
      });
    }, {});
  }

}

export const PropsService = new NativePropsService();